<template>
    <div>
        <BorderSetting ref="form" :config="config" :predefine-theme-colors="predefineThemeColors" />
    </div>
</template>
<script>
import BorderSetting from '@/components/data-room-ui/packages/bigScreen/BorderSetting.vue'
import { predefineColors } from "@/components/data-room-ui/packages/js/utils/colorList";
export default {
    name: 'Border9Setting',
    components: {
        BorderSetting
    },
    data() {
        return {
            // 预设主题色
            predefineThemeColors: predefineColors
        }
    },
    computed: {
        config: {
            get() {
                return this.$store.state.bigScreen.activeItemConfig
            },
            set(val) {
                this.$store.state.bigScreen.activeItemConfig = val
            }
        }
    },
    watch: {},
    mounted() { },
    methods: {}
}
</script>
